import React from 'react'
import styled, { keyframes } from 'styled-components'

const glowAnimation = keyframes`
  0%, 100% {
    text-shadow: 0 0 20px rgba(100, 149, 237, 0.5),
                 0 0 40px rgba(100, 149, 237, 0.3),
                 0 0 60px rgba(100, 149, 237, 0.2);
  }
  50% {
    text-shadow: 0 0 30px rgba(100, 149, 237, 0.8),
                 0 0 60px rgba(100, 149, 237, 0.5),
                 0 0 90px rgba(100, 149, 237, 0.3);
  }
`

const slideDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`

const HeaderContainer = styled.div`
  position: relative
  z-index: 10
  padding: 40px 0 20px 0
  display: flex
  justify-content: center
  align-items: center
  background: transparent

  @media (max-width: 1200px) {
    padding: 30px 0 15px 0
  }

  @media (max-width: 768px) {
    padding: 25px 0 10px 0
  }

  @media (max-width: 480px) {
    padding: 20px 0 10px 0
  }
`

const TitleWrapper = styled.div`
  text-align: center
  animation: ${slideDown} 1s ease-out
`

const MainTitle = styled.h1`
  font-size: 5.6rem !important
  font-weight: 800 !important
  color: #ffffff !important
  margin: 0 !important
  letter-spacing: 6px
  font-family: 'Arial', 'Helvetica', sans-serif !important
  text-transform: uppercase
  animation: ${glowAnimation} 3s ease-in-out infinite
  background: linear-gradient(135deg, #6495ed 0%, #4169e1 50%, #1e90ff 100%) !important
  -webkit-background-clip: text !important
  -webkit-text-fill-color: transparent !important
  background-clip: text !important
  position: relative
  z-index: 1000

  &::before {
    content: 'BACKOFFICE'
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: linear-gradient(135deg, #ffffff 0%, #e6e6fa 100%)
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
    background-clip: text
    z-index: -1
    filter: blur(2px)
    opacity: 0.3
  }

  @media (max-width: 1200px) {
    font-size: 4.8rem
    letter-spacing: 4px
  }

  @media (max-width: 768px) {
    font-size: 4rem
    letter-spacing: 3px
  }

  @media (max-width: 480px) {
    font-size: 3.2rem
    letter-spacing: 2px
  }
`

const SubTitle = styled.p`
  font-size: 1.8rem !important
  color: rgba(255, 255, 255, 0.7) !important
  margin: 12px 0 0 0 !important
  letter-spacing: 3px
  font-weight: 300 !important
  text-transform: uppercase
  z-index: 1000
  position: relative

  @media (max-width: 1200px) {
    font-size: 1.6rem
    letter-spacing: 2px
  }

  @media (max-width: 768px) {
    font-size: 1.4rem
    letter-spacing: 1.5px
  }

  @media (max-width: 480px) {
    font-size: 1.2rem
    letter-spacing: 1px
  }
`

const DecorativeLine = styled.div`
  width: 60px
  height: 2px
  background: linear-gradient(90deg, transparent, #6495ed, transparent)
  margin: 15px auto 0
  border-radius: 1px
  box-shadow: 0 0 10px rgba(100, 149, 237, 0.5)

  @media (max-width: 480px) {
    width: 40px
    margin: 10px auto 0
  }
`

interface BackofficeHeaderProps {
  subtitle?: string
}

const BackofficeHeader: React.FC<BackofficeHeaderProps> = ({
  subtitle = "ADMIN CONTROL PANEL"
}) => {
  return (
    <HeaderContainer
      style={{
        position: 'relative',
        zIndex: 10,
        padding: '20px 0 10px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'transparent'
      }}
    >
      <TitleWrapper style={{ textAlign: 'center' }}>
        <MainTitle
          style={{
            fontSize: '4.2rem',
            fontWeight: 800,
            color: '#212529',
            margin: 0,
            letterSpacing: '4px',
            fontFamily: 'Arial, Helvetica, sans-serif',
            textTransform: 'uppercase',
            background: 'linear-gradient(135deg, #343a40 0%, #495057 50%, #6c757d 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            position: 'relative',
            zIndex: 1000
          }}
        >
          BACKOFFICE
        </MainTitle>
        <SubTitle
          style={{
            fontSize: '1.2rem',
            color: 'rgba(52, 58, 64, 0.8)',
            margin: '8px 0 0 0',
            letterSpacing: '2px',
            fontWeight: 300,
            textTransform: 'uppercase',
            zIndex: 1000,
            position: 'relative'
          }}
        >
          {subtitle}
        </SubTitle>
        <DecorativeLine
          style={{
            width: '50px',
            height: '2px',
            background: 'linear-gradient(90deg, transparent, #495057, transparent)',
            margin: '10px auto 0',
            borderRadius: '1px',
            boxShadow: '0 0 10px rgba(73, 80, 87, 0.3)'
          }}
        />
      </TitleWrapper>
    </HeaderContainer>
  )
}

export default BackofficeHeader